import React from 'react'

const DownArrowIcon = (props) =>(
	<svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6"><path d="M10 1.326l-1.418-1.326-3.582 3.348-3.582-3.348-1.418 1.326 5 4.674z" fill={props.fill} /></svg>
)

export default DownArrowIcon